export class AttributeGroup {
  private _id: string;
  private _name: string;
  private _rank: number;
  private _filterable: boolean;
  private _appearsInDrawer: boolean;
  private _attributeDefinitionIds: Array<string> = new Array<string>();

  private constructor(
    id: string,
    name: string,
    rank: number,
    appearsInDrawer: boolean,
    filterable: boolean,
    attributeDefinitionIds: Array<string>
  ) {
    this._id = id;
    this._name = name;
    this._rank = rank;
    this._appearsInDrawer = appearsInDrawer;
    this._filterable = filterable;
    this._attributeDefinitionIds = attributeDefinitionIds;
  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  get rank(): number {
    return this._rank;
  }

  get appearsInDrawer(): boolean {
    return this._appearsInDrawer;
  }

  get filterable(): boolean {
    return this._filterable;
  }

  get attributeDefinitionIds(): Array<string> {
    return this._attributeDefinitionIds;
  }

  static parse(data: any): AttributeGroup {
    return new AttributeGroup(
      data.id,
      data.name,
      data.rank,
      data.appearsInDrawer,
      data.filterable,
      data.attributeDefinitionIds
    );
  }
}
